/**
 * MasterGradeBadge - Gjenbrukbar Master Grade-indikator
 * Brukes i alle modul-modaler og beskrivelser
 */
import { Shield } from 'lucide-react';

export function MasterGradeBadge({ description }) {
  return (
    <div className="bg-gradient-to-r from-[var(--copper)]/10 to-transparent border border-[var(--copper)]/30 rounded-lg p-4">
      <div className="flex items-center gap-2 mb-2">
        <Shield className="w-5 h-5 text-[var(--copper)]" />
        <span className="text-sm font-semibold text-[var(--copper)]">Master Grade</span>
      </div>
      <p className="text-sm text-[var(--text-muted)] leading-relaxed">
        En <strong className="text-[var(--text-main)]">Master-modul</strong> {description}
      </p>
    </div>
  );
}

export default MasterGradeBadge;
